import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b3be84a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./converterMolecularWeight.scss?vue&type=style&index=0&id=3b3be84a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3be84a",
  null
  
)

export default component.exports